import { css } from "@compiled/react";
import Lottie, { Options, EventListener } from "react-lottie";

const jiraWireFrameStyle = css({
    overflow: "hidden",
    zIndex: 1
});

interface LottieAnimationProps {
    options: Options;
    eventListener: EventListener[] | undefined;
    isAnimationBrandRefresh?: boolean;
}

export const LottieAnimation = ({
    options,
    eventListener
}: LottieAnimationProps) => (
    <div css={[jiraWireFrameStyle]}>
        <Lottie options={options} eventListeners={eventListener} />
    </div>
);
